<template>
  <div class="content">
    <div class="table-container">
      <div class="table-container-top">
        <h2 class="table-container-title">出库单</h2>
        <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="left">
          <div class="table-header-info">
            <el-form-item label="客户名称" prop="customerName" style="margin-bottom:0px" :show-message="false">
              <el-input v-model="form.customerName" clearable placeholder="请输入客户名称"></el-input>
            </el-form-item>
          </div>
          <el-table :data="form.contentList" :span-method="handleSpan" border style="width: 100%" align="center"  class="custom-table">
            <el-table-column prop="index" label="序号" align="center" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.total">{{scope.row.categoryName}}</span>
                <span v-else-if="scope.row.remarkLast">{{scope.row.categoryName}}</span>
                <span v-else>{{scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" align="center" label="品名" width="140">
              <template slot-scope="{ row }">
                <el-autocomplete
                  popper-class="my-autocomplete"
                  v-model="row.categoryName"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容">
                  <i
                    class="el-icon-edit el-input__icon"
                    slot="suffix"
                    >
                  </i>
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.value }}</div>
                  </template>
                </el-autocomplete>
              </template>
            </el-table-column>
            <el-table-column prop="quantity" align="center" label="数量" width="160">
              <template slot-scope="{ row }">
                <span v-if="row.total" style="font-size: 18px;font-weight: 600;color:red">{{totalQuantity}}</span>
                <el-input-number v-else  size="medium" style="width:130px" v-model="row.quantity" :step="1"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="units" align="center" label="单位" width="100">
              <template slot-scope="{ row }">
                <el-input v-model="row.units" clearable class="input-center"/>
              </template>
            </el-table-column>
            <el-table-column label="价格" align="center" prop="unitPrice" width="160">
              <template slot-scope="{ row }">
                <el-input-number size="medium" style="width:130px" v-model="row.unitPrice" :precision="2" :step="1"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="货款" align="center" prop="paymentGoods" width="100">
              <template slot-scope="{ row }">
                <el-input v-model="row.paymentGoods" clearable/>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" header-align="center" align="left" min-width="260">
              <template slot-scope="{ row }">
                <el-input type="textarea" v-if="!!row.rows" v-model="row.remark" clearable class="bold-input" :autosize="{ minRows: 3, maxRows: 6}"></el-input>
                <el-input type="textarea" v-else v-model="row.remark" clearable class="bold-input" :autosize="{ minRows: 1, maxRows: 6}"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="90">
              <template slot-scope="{ $index }">
                    <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" circle @click="addRow($index)"></el-button>
                    <el-button size="mini" type="danger" v-if="$index>0" icon="el-icon-remove-outline" circle @click="deleteRow($index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="table-footer-info">
            <span class="footer-info-item"><strong>制单：</strong></span>
            <span class="footer-info-item"><strong>财务：</strong></span>
            <span class="footer-info-item"><strong>仓库：</strong></span>
            <span class="footer-info-item"><strong>客户签名：</strong></span>
          </div>
          <!-- 在表单结尾处添加按钮 -->
          <div class="button-group">
            <el-button type="primary" @click="saveOutEntre">保存</el-button>
            <el-button type="success" @click="submitAndFlow">提交</el-button>
          </div>
        </el-form>
      </div>
      <!-- 下半部分内容 -->
      <div class="table-container-bottom" v-if="!!shipmentId">
        <Shipment :shipmentId="shipmentId" @child-event="handleChildEvent"/>
      </div>
    </div>
  </div>
</template>
<script>
  import {outEntrepotDetailById, submitAndFlowOutEntrepot, saveOutEntrepot, editOutEntrepot } from "@/api/api.js";
  import Shipment from "./info/Shipment.vue";
  import webSocketService from '@/utils/WebSocketService';
  export default {
    name: "outEntrepotUpdate",
    components: {Shipment},
    data() {
      return{
        id: this.$route.query.id,
        shipmentId: this.$route.query.shipmentId,
        shipmentNo: null,
        restaurants: [
          { "value": "电信卡" },
          { "value": "移动卡" },
          { "value": "联通卡" },
          { "value": "国际卡" },
          { "value": "eSIM卡" },
          { "value": "vSIM卡" },
          { "value": "二维码" }
        ],
        noticeRemark:'.物联卡机卡绑定，更换设备或被销卡，请联系客服查询；请勿插在手机等移动端使用，经检测将被关停。\n.本产品仅限于在规定的广告机设备上使用，请勿用作他途。',
        form:{
          contentList:[
            {quantity:1,unitPrice:0.00}
            ,{total: true,categoryName:'合计',remark:'.物联卡机卡绑定，更换设备或被销卡，请联系客服查询；请勿插在手机等移动端使用，经检测将被关停。\n.本产品仅限于在规定的广告机设备上使用，请勿用作他途。',rows:2}
            ,{remarkLast: true,categoryName:'备注',remark:'ICCID卡号：（请与实物核对卡号）',rows:4}
          ]
        },
        rules: {
          customerName: [
            { required: true, message: '请输入客户名称', trigger: 'blur' },
          ],
        }
      }
    },
    computed: {
      // 计算属性，实时计算总数
      totalQuantity() {
          return this.form.contentList
            .filter(item => !item.total && !item.remarkLast)
            .reduce((sum, item) => sum + (item.quantity || 0), 0);
      }
    },
    methods: {
      //导出excel出库单
      handleSpan({ row, column, rowIndex, columnIndex }) {
        if (row.total) {
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 2 }; // 合并序号、品名
          } else if (columnIndex < 2) {
            return { rowspan: 1, colspan: 0 }; // 隐藏品名
          } else if (columnIndex === 2) {
            return { rowspan: 1, colspan: 1 }; // 显示数量列
          } else if (columnIndex === 6) {
            return { rowspan: 1, colspan: 5 }; // 显示1行4列
          }else {
            return { rowspan: 1, colspan: 0 }; // 隐藏其他列
          }
        } else if (row.remarkLast) {
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 1 };
          } else if(columnIndex === 6) {
            return { rowspan: 1, colspan: 7 }; // 备注内容跨后七列
          }else{
            return { rowspan: 1, colspan: 0 }; // 隐藏其他列
          }
        }
      },
      //获取出库单数据
      initData() {
          if (!!this.id) {
            outEntrepotDetailById({id: this.id}).then(res=>{
                this.form = res.data.data;
                if(!this.form.contentList || this.form.contentList.length==0){
                  this.form.contentList.push({quantity:1,unitPrice:0.00})
                }
                let nt = res.data.data.noticeRemark;
                let amountRow={total: true,categoryName:'合计',quantity:res.data.data.total,remark: !!nt?nt:this.noticeRemark,rows:3}
                let rk = res.data.data.remark
                let remarkRow={remarkLast: true,categoryName:'备注',remark:!!rk?rk:'ICCID卡号：（请与实物核对卡号）',rows:4}
                this.form.contentList.push(amountRow,remarkRow)
            });
          }
      },
      querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      deleteRow(index) {
        if (this.form.contentList.length > 1) {
          this.form.contentList.splice(index, 1)
        }
      },
      addRow(index){
        this.form.contentList.splice(index + 1, 0, {quantity:1,unitPrice:0.00})
      },
      getNoticeRemark(){
        return this.form.contentList.find(item => item && item.total === true);
      },
      getRemark(){
        return this.form.contentList.find(item => item && item.remarkLast === true);
      },
      getContentList(){
        return this.form.contentList.filter(item => !item.total && !item.remarkLast);
      },
      saveOutEntre(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            let formData = Object.assign({},this.form);
            formData.contentList = this.getContentList();
            formData.shipmentId = this.shipmentId;
            formData.shipmentNo = this.shipmentNo;
            formData.total = this.totalQuantity;
            let notice = this.getNoticeRemark();
            formData.noticeRemark = notice && notice.remark
            let remark = this.getRemark()
            formData.remark = remark && remark.remark
            if(!!this.id){
              editOutEntrepot(formData).then((res) => {
                  this.$message.success("出库单编辑成功");
                  this.$store.dispatch('tagsView/delView', this.$route);
                  this.$router.push("/shipment/outEntrepot");
              });
            }else{
              saveOutEntrepot(formData).then((res) => {
                  this.$message.success("出库单保存成功");
                  this.$store.dispatch('tagsView/delView', this.$route);
                  this.$router.push("/shipment/outEntrepot");
              });
            }
          }
        });
      },
      submitAndFlow(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            if(this.form.contentList.length==0){
              this.$message.error("出库单内容不能全部为空");
              return
            }
            let filteredArray = this.getContentList().filter(function(item) {
              return !!item.categoryName && !!item.units && !!item.quantity
            });
            if(filteredArray.length==0){
              this.$message.error("出库单品名/数量/单位，不能为空");
              return
            }
            let formData = Object.assign({},this.form);
            formData.contentList = this.getContentList();
            formData.shipmentId = this.shipmentId;
            formData.shipmentNo = this.shipmentNo;
            formData.total = this.totalQuantity;
            let notice = this.getNoticeRemark();
            formData.noticeRemark = notice && notice.remark
            let remark = this.getRemark()
            formData.remark = remark && remark.remark
            submitAndFlowOutEntrepot(formData).then((res) => {
              this.$message.success("提交出库单成功");
              // 提交WebSocket消息主题
              this.submitWebSocketMessage();
              this.$store.dispatch('tagsView/delView', this.$route);
              this.$router.push("/shipment/outEntrepot");
            });
          }
        })
      },

      handleChildEvent(data) {
        this.shipmentNo = data.value;
      },
      // 提交WebSocket消息主题
      submitWebSocketMessage() {
          //payload
          const message = {
              key:"entrepot",
              timestamp: Date.now(),
          };
          webSocketService.sendToTopic('/topic/entrepot', message);
      },
    },
    created() {
      this.initData()
    },
      watch: {
          '$route': {
              handler: function (to, from) {
                  if (to.name == "outEntrepotUpdate") {
                      if (!to.query.id) {
                          this.form = {
                              contentList:[
                                  {quantity:1,unitPrice:0.00}
                                  ,{total: true,categoryName:'合计',remark:'.物联卡机卡绑定，更换设备或被销卡，请联系客服查询；请勿插在手机等移动端使用，经检测将被关停。\n.本产品仅限于在规定的广告机设备上使用，请勿用作他途。',rows:2}
                                  ,{remarkLast: true,categoryName:'备注',remark:'ICCID卡号：（请与实物核对卡号）',rows:4}
                              ]
                          }
                      } else {
                          if (this.id != to.query.id) {
                              this.id = to.query.id;
                              this.initData();
                          }
                      }
                  }
              },
              // 深度观察监听
              deep: true,
          },
      },
  };
</script>
<style scoped lang="less">
  .content {
    display: flex;
    justify-content: center;
    padding-top: 20px;
  }
  .table-container {
    width: 80%;
    max-width: 1200px; 
    .table-container-title{
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .table-header-info {
      margin-bottom: 6px;
      display: flex;
      gap: 100px; /* 调整信息项之间的间距 */
    }
    .table-footer-info {
      margin-top: 6px;
      display: flex;
      gap: 120px; 
    }
    .info-item {
      font-size: 18px;
    }
    .footer-info-item{
      font-size: 15px;
    }
    .el-table {
      text-align: center;
      td, th {
        text-align: center !important;
      }
    }
    .el-form-item span {
      display: inline-block;
      padding-top: 6px;
    }
    .filter-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;
    }
    /deep/ .custom-table{
      border: 1px solid black;
      /* 表头样式 */
      .el-table__header {
        background-color: black;
        color: white;
      }
      /* 表格主体样式 */
      .el-table__body {
        background-color: white;
      }
      /* 单元格边框样式 */
      .el-table__body-wrapper td {
        border-color: black !important;
      }
      .el-table__header-wrapper th {
        border-color: black !important;
      }
      /* 单元格之间的分隔线 */
      .el-table__body-wrapper tr td {
        border-right: 1px solid black;
      }
       .el-table__body-wrapper tr td:last-child {
        border-right: none;
      }
      /* 表头分隔线样式 */
      .el-table__header-wrapper th.is-leaf {
        border-bottom: 1px solid black;
      }
      /* 表格底部边框样式 */
      .el-table__body-wrapper tr:last-child td {
        border-bottom: 1px solid black;
      }

    }
    /deep/ .input-center {
      .el-input__inner {
        text-align: center;
      }
    }
    .button-group {
      margin-top: 20px;
      /* 使用 flex 布局，让子元素水平居中 */
      display: flex;
      justify-content: center;
      /* 可选：若需要垂直居中 */
      align-items: center; 
    }

    .button-group .el-button {
      margin: 0 10px;
    }
  }

  /* 可添加样式控制富文本内容的显示 */
  .el-table .el-table__cell div[v-html] {
    word-break: break-word; /* 允许长单词换行 */
  }
  /* 设置表头字体大小和粗细 */
  /deep/ .el-table thead th {
    font-size: 16px; 
    font-weight: 600; 
  }
  /deep/ .bold-input .el-textarea__inner {
    font-weight: 600;
    font-size: 13px; /* 可根据需求调整字体大小 */
  }
  
</style>


